import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteJob } from "./DeleteJobApi";


const initialState = {
    confirmation: '',
    isLoading: false,
    isError: false,
    error: "",
};

export const removeJob = createAsyncThunk('deleteJobs/delete', async(id) =>{
    const Job = await deleteJob(id);
    return Job;
})
    
const deleteJobSlice = createSlice({
    name: "deleteJob",
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(removeJob.pending, (state) => {
                state.isError = false;
                state.isLoading = true;
            })
            .addCase(removeJob.fulfilled, (state, action) => {
                state.isError = false;
                state.isLoading = false;
                state.confirmation = action.payload;
            })
            .addCase(removeJob.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.error = action.error?.message;
                state.confirmation = {};
            })
        }
})


export default deleteJobSlice.reducer;